import { httpManager as http } from '@/plugins/HttpManager';
import { getIANATimeZone } from '@/utils/time';
import { IOrderPreview, ICreateOrderArgs, IOrder, IOrderPreviewArgs, IPreviewFreeOffer_BodyArgs, IGetPlanByIdRes, IGetFreeOfferPlanArgs, IGetPromotionsBodyArguments, IGetPromotionsRes } from '@reolink-cloud/interface';
import { errorUploader } from '@/lib/errorUploader';

export const previewOrder =
    async ( args: IOrderPreviewArgs ): Promise<IOrderPreview> => {

        try {

            const { data } = await http.post( '/shop/orders/preview/', { ...args, context:{ ...args.context, timezone: getIANATimeZone() } } as IOrderPreviewArgs, {

                frequency: 'previewSubscription'

            });

            return data;

        } catch ( e: unknown ) {

            errorUploader.uploadApiError( 'previewOrder', e, 'middle', ['shippingInfo'] );
            throw e;

        }

    };

export const createOrder = async ( options: ICreateOrderArgs ): Promise<IOrder> => {

    const { data } = await http.post( '/shop/orders', options );
    return data;

};

export const previewFreeOrder = async ( options: IPreviewFreeOffer_BodyArgs ): Promise<IOrderPreview> => {

    const { data } = await http.post( '/shop/device/x-plan/preview', options );
    return data;

};

/**
 * 不需要鉴权即可获取可免费领取的套餐
 * @param options
 * @returns
 */
export const getFreeOrderPlan = async ( options: IGetFreeOfferPlanArgs ): Promise<IGetPlanByIdRes> => {

    const { data } = await http.post( '/cloud/device/x-plan/view', options );
    return data;

};

export const createFreeOrder = async ( options: IPreviewFreeOffer_BodyArgs ): Promise<IOrder> => {

    const { data } = await http.post( '/shop/device/x-plan', options );
    return data;

};

export const getPromotionItems = async ( args: IGetPromotionsBodyArguments ): Promise<IGetPromotionsRes> => {

    const { data } = await http.post<IGetPromotionsRes>( '/cloud/promotions', { ...args, timezone: getIANATimeZone() });
    return data;

};
